import React, { Component } from 'react'
import './style.css'
import Grid from './grid'
import {Button} from '@material-ui/core'
import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'

import insight1 from '../../assets/image/insight1.jpg'
import insight2 from '../../assets/image/insight2.jpg'
import insight3 from '../../assets/image/insight3.jpg'
import insight4 from '../../assets/image/insight4.jpg'
import {data_insight} from '../../dummy/data'
import {getInsight} from '../../redux/action/insight'
import {connect} from 'react-redux'
import Skeleton from 'react-loading-skeleton'

class insight extends Component {
    componentDidMount(){
        this.props.getInsight(`/${this.props.jumlah}`)
    }
    loader=()=>{
        return(
            <div className='loader-skeleton'>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
            </div>
        )
    }
    render() {
        let {jumlah,insight,general}=this.props
        let new_data=[]
        data_insight.map((data,i)=>{
            if(i<jumlah){
                new_data.push(data)
            }
        })
        console.log('insight',insight.list_insight)
        return (
            <div>
                 <div className='head'>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'flex-start'}}>                        
                    <h2>Insight </h2>
                    &nbsp;&nbsp;&nbsp;
                    <div className='event-header-joinwithus hidden-mobile' style={{width:1,height:40,backgroundColor:'grey'}}></div>
                    &nbsp;&nbsp;&nbsp;
                    <p className='event-header-joinwithus hidden-mobile'>Check out our latest thinking</p>
                    </div>
                    <div>
                        <Button style={{textTransform:'none',fontWeight:'bold'}} color="primary" onClick={()=>window.location.assign('/insight')}>More insight </Button>
                    </div>
                </div>
                <br/>
                {general.isLoading?this.loader():<Grid data={insight.list_insight} />}
            </div>
        )
    }
}
const mapStateToProps=(state)=>({
    general:state.general,
    insight:state.insight
})
const mapDispatchToProps={
    getInsight
}
export default connect(mapStateToProps,mapDispatchToProps)(insight)